import { render, staticRenderFns } from "./cache.vue?vue&type=template&id=703cc661&scoped=true"
import script from "./cache.vue?vue&type=script&lang=ts"
export * from "./cache.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703cc661",
  null
  
)

export default component.exports